import {Directive, inject, OnDestroy} from '@angular/core';
import {GlobalRecordTypeMaps}         from '@djsharkk/logr-types';
import {Subject}                      from 'rxjs';
import {takeUntil}                    from 'rxjs/operators';
import {DataFactoryService}           from '../../../../../logr-services/data/data-factory.service';
import {FirebaseToolsService}         from '../../../../../logr-services/firebase/firebase-tools.service';
import {TableToolsService}            from '../../../../comps/table/table-tools.service';
import {TableRow}                     from '../../../../comps/table/table-wrapper/table-wrapper.component';
import {PanelMenuConfRowIntf}         from './menu-crud-panel-top/menu-crud-tile/menu-crud-tile.component';

@Directive()
export abstract class MenuCrudPanelContentBase<DATA, CONF> implements OnDestroy {
	svcDataFactory = inject(DataFactoryService);
	svcFirebaseTools = inject(FirebaseToolsService);
	svcTableTools = inject(TableToolsService);

	layoutAsToggle: boolean;

	recordRowsLogs: TableRow<DATA>[] = [];
	recordRowsConf: CONF[] = [];
	recordConfBtns: PanelMenuConfRowIntf[] = [];

	// Subject used to manage unsubscriptions
	destroy$ = new Subject<void>();

	protected constructor(private typeKey: keyof typeof this.svcDataFactory['crudDataSvcs'], toggle: boolean) {
		this.layoutAsToggle = toggle;

		this.svcDataFactory.crudDataSvcs[this.typeKey]
			.getRecordsLogDates([new Date()])
			.pipe(takeUntil(this.destroy$)) // Use the `takeUntil` operator
			.subscribe(records => {
				this.recordRowsLogs = this.svcTableTools.buildTableRows(
					records as GlobalRecordTypeMaps[typeof this.typeKey][],
					this.typeKey
				);
			});
	}

	public ngOnDestroy() {
		// Emit a value to clean up subscriptions
		this.destroy$.next();
		this.destroy$.complete();
	}
}